import { VisualChartSortingGroup } from './chart-type';
import { PbiDataRoles } from './data-role';

export const SortingGroups: Record<string, VisualChartSortingGroup> = {
  tableColumns: {
    order: 0,
    name: 'tableColumns',
    title: 'tableColumns',
    dataRoles: [
      PbiDataRoles.pivotTableColumns,
      PbiDataRoles.pivotTableRows,
      PbiDataRoles.pivotTableMeasures,
      PbiDataRoles.tableFields
    ],
    maxFields: 9999
  },

  pivotTableColumns: {
    order: 0,
    name: 'pivotTableColumns',
    title: 'pivotTableColumns',
    dataRoles: [
      PbiDataRoles.pivotTableColumns,
      PbiDataRoles.pivotTableRows,
      PbiDataRoles.pivotTableMeasures,
      PbiDataRoles.tableFields
    ],
    maxFields: 1
  },


  chartAxis: {
    order: 1,
    name: 'axis',
    title: 'Axis',
    dataRoles: [PbiDataRoles.chartAxis, PbiDataRoles.chartMeasures],
    alternativeFieldSortingDataRole: 'Tooltips',
    maxFields: 1
  },

  chartLegend: {
    order: 0,
    name: 'legend',
    title: 'Legend',
    dataRoles: [PbiDataRoles.chartLegend],
    maxFields: 1
  },


  pieValue: {
    order: 1,
    name: 'value',
    title: 'Legend',
    dataRoles: [PbiDataRoles.pieDonutLegend, PbiDataRoles.pieDonutMeasures],
    maxFields: 1
  },

  pieDetails: {
    order: 0,
    name: 'details',
    title: 'Details',
    dataRoles: [PbiDataRoles.pieDonutDetails],
    maxFields: 1
  },


  waterfallValue: {
    order: 0,
    name: 'category',
    title: 'Category',
    dataRoles: [PbiDataRoles.waterfallCategory, PbiDataRoles.chartMeasures],
    alternativeFieldSortingDataRole: 'Tooltips',
    maxFields: 1
  }
}
